var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.completed)?_c('div',{staticClass:"parent"},[_c('div',{staticClass:"progress-box"},[_c('ProgressBarMulti',{attrs:{"values":_vm.percentage,"min":0,"max":100}})],1),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.value || 0)+"%\n  ")])]):_c('div',[_vm._v("\n  "+_vm._s(_vm.t('generic.completed'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }